import type { Tag } from '@entities/tag';
import type { TagRepository } from '@infra/repositories/tag.repository';

/**
 * In-memory, session-scoped store for the account's available tags and the
 * tags applied per call. The Aircall API is the source of truth; this only
 * backs the wrap-up UI and the mandatory-tagging gate for the current session.
 */
export class MemTagRepository implements TagRepository {
  private availableTags: Tag[] = [];
  private appliedTagsByCall: Map<string, number[]> = new Map();

  setAvailableTags(tags: Tag[]): void {
    this.availableTags = [...tags];
  }

  // Defensive copy so callers cannot mutate internal state.
  getAvailableTags(): Tag[] {
    return [...this.availableTags];
  }

  setAppliedTags(callId: string, tagIds: number[]): void {
    this.appliedTagsByCall.set(callId, [...tagIds]);
  }

  getAppliedTags(callId: string): number[] {
    return [...(this.appliedTagsByCall.get(callId) ?? [])];
  }

  clearAppliedTags(callId: string): void {
    this.appliedTagsByCall.delete(callId);
  }
}
